import { WearableDataDBType } from '@type';

import { CommunicationKeys, Preferences } from '../types';
import { BaseGateway } from './base.gateway';

export class StatsGateway extends BaseGateway {
  requestSubmittedTasksData = async (siteUuid: string) => {
    return await this.dataExchange<{
      document: string;
      encryption: boolean;
      siteId: number;
    }>({
      successKey: CommunicationKeys.TaskSubmittedData.Success,
      failureKey: CommunicationKeys.TaskSubmittedData.Failure,
      siteUuid: siteUuid,
      payload: {
        preference: Preferences.Stats.SubmittedTasksData,
      },
    }).catch(error => {
      throw new Error(
        `Error on getting task submitted data: ${JSON.stringify(error)}`
      );
    });
  };

  requestHealthData = async (
    siteUuid: string,
    params: {
      measurementCount: number;
      aggregationFilter: 'week';
      aggregatedDataTypes: WearableDataDBType[];
      rawDataTypes: WearableDataDBType[];
      order: 'desc';
    } = {
      measurementCount: 7,
      aggregationFilter: 'week',
      aggregatedDataTypes: [WearableDataDBType.Steps],
      rawDataTypes: [
        WearableDataDBType.Bpm,
        WearableDataDBType.BloodPressure,
        WearableDataDBType.Weight,
        WearableDataDBType.Spo2,
        WearableDataDBType.BloodGlucose,
      ],
      order: 'desc',
    }
  ) => {
    return await this.dataExchange<{
      data: {
        encryptedWearableData: string;
        siteId: number;
      };
    }>({
      successKey: CommunicationKeys.Wearables.GetWerableDataSuccess,
      failureKey: CommunicationKeys.Wearables.GetWerableDataFailure,
      siteUuid: siteUuid,
      payload: {
        preference: Preferences.Wearables.GetWearablesData,
        params,
      },
    }).catch(error => {
      throw new Error(
        `Error on getting stored health data: ${JSON.stringify(error)}`
      );
    });
  };
}
